import { CommonModule } from '@angular/common';
import { ApplicationRef, Component, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { FormsModule } from '@angular/forms';
import config from 'devextreme/core/config';
import { licenseKey } from '../devextreamLicence';
import { CommonService } from './core/services/common/common.service';
import { environment } from '../environments/environment';
import { filter } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { HotToastService } from '@ngxpert/hot-toast';

config({ licenseKey });

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterOutlet, FormsModule, CommonModule],
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'gmex-ui';

  private screenId = 'nevigateToSellerScreen';
  private readonly ignoredRoutes = [
    '/',
    '/signin',
    '/signup',
    '/forgot',
    '/reset',
    '/invite',
    '/gmex/packaging-slip/previewSlip'
  ];
  constructor(private commonService: CommonService, private router: Router, private appRef: ApplicationRef, private toastr: HotToastService) {
  }

  ngOnInit() {

    history.pushState(null, '', location.href);

    window.onpopstate = () => {
      history.pushState(null, '', location.href);
    };
    this.commonService.loadWelcomeStatus();
    

    // const tokenData = this.commonService.GetStorage('token', 'local');
    // const route = tokenData ? './gmex/dashboard' : './signin';
    // this.router.navigate([route]);
    const tokenData = this.commonService.GetStorage('token', 'local');
    // Public pages (invite link etc.) must open without a token.
    const currentPath = location.hash.replace(/^#/, '').split('?')[0] || '/';
    if (tokenData == null && !this.shouldIgnoreRoute(currentPath)) {
      this.router.navigate(['./signin']);
    }
    this.appRef.isStable.subscribe((isStable) => {
      if (isStable) {
        setTimeout(() => this.commonService.initVersionCheck(1), 1000); // check every 1 minute
      }
    });

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const currentRoute = event.urlAfterRedirects?.trim();
        if (currentRoute && !this.shouldIgnoreRoute(currentRoute)) {
          this.saveCurrentRoute(currentRoute, tokenData);
        }
      });
  }
  private shouldIgnoreRoute(route: string): boolean {
    return this.ignoredRoutes.some(ignore => route === ignore || route.startsWith(ignore + '/'));
  }

  private saveCurrentRoute(route: string, tokenData): void {
    if (!tokenData) return; // 🚫 skip if no token
    const token = this.commonService.GetStorage('token', 'local');

    // 🔹 Skip saving if user not logged in
    if (!token) return;

    // 🔹 Skip saving if route should be ignored (like /signin, /forgot)
    if (this.shouldIgnoreRoute(route)) return;

    // 🔹 Skip saving one-time after login redirect
    const skipNext = this.commonService.GetStorage('skipNextSave', 'session');
    if (skipNext) {
      this.commonService.RemoveStorage('skipNextSave', 'session');
      return; // 🚫 Don’t save this route
    }
    const params = {
      screenId: this.screenId,
      propertylst: [
        { propertyName: 'MainRoute', propertyValue: route }
      ]
    };
    // ✅ Otherwise, save it normally
    this.commonService.setFormStateManage(params).subscribe({
      next: () => { },
      error: (error) => {
      },
    });
  }
}
